// extracted by mini-css-extract-plugin
export var active = "_fb-7";
export var blink = "_fb-8";
export var dropDownSelector = "_fb-4";
export var dropDownWrapper = "_fb-3";
export var fakeCursor = "_fb-6";
export var fontSizeButton = "_fb-9";
export var formQuillEditor = "_fb-0";
export var pressed = "_fb-a";
export var qlBlank = "_fb-1";
export var textFormattingToolbar = "_fb-2";
export var textToolbarOption = "_fb-5";